const BrowserTargets = {
  GeneOntology: 'go',
  Ndex: 'ndex',
  Portal: 'portal'
}

export default BrowserTargets
